"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LogModel;
(function (LogModel) {
    LogModel[LogModel["LocalStorage"] = 0] = "LocalStorage";
    LogModel[LogModel["IndexedDB"] = 1] = "IndexedDB";
    LogModel[LogModel["Websql"] = 2] = "Websql";
})(LogModel = exports.LogModel || (exports.LogModel = {}));
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["Verbose"] = 0] = "Verbose";
    LogLevel[LogLevel["Debug"] = 1] = "Debug";
    LogLevel[LogLevel["Info"] = 2] = "Info";
    LogLevel[LogLevel["Warn"] = 3] = "Warn";
    LogLevel[LogLevel["Error"] = 4] = "Error";
    LogLevel[LogLevel["Success"] = 5] = "Success";
})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
//# sourceMappingURL=ILogger.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/limi-lib/dist/lib/limi/log/ILogger.js
// module id = u7kX
// module chunks = 0